import FieldConfig from "../../../../proto/field-config"
import FieldDate from "../../../../generic/datetime/date/date"
import Task from "../../../../../model2/task/task"
import {FIELD_CONDITIONS_DATE} from "../../../../conditions/date"

export default class FieldTaskLatestActivityMoment extends FieldDate {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel              = "Last updated";
        this.label                  = "Last updated";
        this.icon                   = 'i5-date-updated'

        this.canManuallySetValue    = false

        this.conditionTypes = FIELD_CONDITIONS_DATE
    }

    canEdit(model:Task):boolean {
        return false
    }

    get requiredBackendFields() {
        return ['latestActivityDate']
    }
}
